type KineticEntry = { node: HTMLElement; animation: Animation[] };

/** M4P: kinetic word splitting is restricted to the hero title; section headings use compositor-only reveal. */
export function setupKineticTypography(reduced: MediaQueryList): () => void {
  if (reduced.matches || document.body.dataset.surface === 'control') return () => undefined;
  const heading = document.querySelector<HTMLElement>('.hero h1');
  if (!heading) return () => undefined;

  const label = heading.innerText.trim().replace(/\s+/g, ' ');
  if (!label) return () => undefined;
  heading.dataset.kineticReady = '1';
  heading.classList.add('kinetic-title');
  heading.setAttribute('aria-label', label);

  const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
  const textNodes: Text[] = [];
  while (walker.nextNode()) textNodes.push(walker.currentNode as Text);

  const animations: Animation[] = [];
  let index = 0;
  for (const node of textNodes) {
    const parent = node.parentElement;
    if (!parent) continue;
    const fragment = document.createDocumentFragment();
    for (const part of (node.nodeValue || '').split(/(\s+)/).filter(Boolean)) {
      if (/^\s+$/.test(part)) {
        const space = document.createElement('span');
        space.className = 'kinetic-space';
        space.setAttribute('aria-hidden', 'true');
        fragment.append(space);
        continue;
      }
      const wrap = document.createElement('span');
      wrap.className = 'kinetic-word-wrap';
      wrap.setAttribute('aria-hidden', 'true');
      const word = document.createElement('span');
      word.className = 'kinetic-word';
      word.textContent = part;
      wrap.append(word);
      fragment.append(wrap);
      const animation = word.animate(
        [{ opacity: 0, transform: 'translate3d(0,104%,0)' }, { opacity: 1, transform: 'translate3d(0,0,0)' }],
        { duration: 560, delay: 40 + index * 28, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'both' },
      );
      animation.onfinish = () => animation.cancel();
      animations.push(animation);
      index += 1;
    }
    parent.replaceChild(fragment, node);
  }

  const entry: KineticEntry = { node: heading, animation: animations };
  return () => entry.animation.forEach((animation) => animation.cancel());
}
